module.exports = __webpack_public_path__ + "static/img/idCarP.5c1f6dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/idCarP.png
// module id = Efy6
// module chunks = 1